const module = {
  firestorePath: 'listings/{listingId}/photos',
  firestoreRefType: 'collection', // or 'doc'
  moduleName: 'listingPhoto',
  statePropName: 'data',
  namespaced: true, // automatically added

  sync: {
    defaultValues: {
      id: '',
      order: 0,
      titleId: '',
      titleEn: '',
      descriptionId: '',
      descriptionEn: '',
      imageUrl: '',
    }
  },

  // this object is your store module (will be added as '/myModule')
  // you can also add state/getters/mutations/actions
  state: {},
  getters: {
    arrayData: state => {
      let data = []

      for (const key in state.data) {
        if (state.data.hasOwnProperty(key)) {
          data.push(state.data[key]);
        }
      }

      return data
    }
  },
  mutations: {
    RESET_LIST: state => state.data = []
  },
  actions: {
    resetList: ({ commit }) => commit('RESET_LIST')
  },
}

export default module
